import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalquery-card',
  templateUrl: './helpbutton-reports-totalquery-card.component.html',
  styleUrls: ['./helpbutton-reports-totalquery-card.component.scss']
})
export class HelpbuttonReportsTotalqueryCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
